import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Information from "./pages/Informations";
import Pagenotfound from "./pages/Pagenotfound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Release from "./release/release";
import ReleaseZeroOne from "./release/release0.1";
import ReleaseOneZero from "./release/release1.0";
import ReleaseTwoZero from "./release/release2.0";
import ReleaseTwoOne from "./release/release2.1";
import ScrollToTop from "./pages/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <div>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/information" element={<Information />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/releases" element={<Release />} />
          <Route path="/release/0.1" element={<ReleaseZeroOne />} />
          <Route path="/release/1.0" element={<ReleaseOneZero/>} />
          <Route path="/release/2.0" element={<ReleaseTwoZero/>} />
          <Route path="/release/2.1" element={<ReleaseTwoOne/>} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes>

      </BrowserRouter>
    </div>
  );
}

export default App;
